/*                                                */
import { closeParam, prefix, type UrlGuardedObservable } from "./useUrlParameter.svelte";

const base64HrefAttribute = "base64-href";
const useCloseUrlQuery = `[data-${prefix}\\.use-close-url]`;
const prevQuery = `[data-${prefix}\\.prev-url]`;
const closeQuery = `[data-${prefix}\\.close-url]`;

/**
 *
 *
 *
 */
type ProcessableElement = HTMLElement & { href?: string };

/**
 *
 *
 *
 *
 *
 *
 */
export const updateElementWithGuardedUrl = (
  element: ProcessableElement,
  guardedUrl: string | undefined,
): void => {
  /*                                               */
  /*                                                                          */
  if (!guardedUrl) {
    element.removeAttribute("href");
    element.removeAttribute(base64HrefAttribute);
    return;
  }

  /*                                                                                          */
  if (element.hasAttribute(base64HrefAttribute)) {
    element.setAttribute(base64HrefAttribute, window.btoa(guardedUrl));
  } else {
    element.href = guardedUrl;
  }
};

/**
 *
 *
 *
 *
 *
 *
 */
export const extendElementWithCloseUrlQueryParam = (
  node: ProcessableElement,
  guardedCloseUrl: string | undefined,
): void => {
  /*                                                                 */
  if (!guardedCloseUrl) return;

  if (node.hasAttribute(base64HrefAttribute)) {
    const newCloseUrl = new URL(
      window.atob(node.getAttribute(base64HrefAttribute) || ""),
      location.href,
    );

    newCloseUrl.searchParams.set(closeParam[0], guardedCloseUrl);
    node.setAttribute(base64HrefAttribute, window.btoa(newCloseUrl.href));
    return;
  }

  /*                                                                                    */
  if (node.href) {
    const newCloseUrl = new URL(node.href, location.href);
    newCloseUrl.searchParams.set(closeParam[0], guardedCloseUrl);

    node.setAttribute("href", newCloseUrl.href);
  }
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useUrlElementsUpdater = (
  Host: HTMLOcFocusedDialogV1Element,
  prevUrlGuarded: UrlGuardedObservable,
  closeUrlGuarded: UrlGuardedObservable,
): void => {
  let isObserverConnected = false;
  const linkAnchorUpdateObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      for (const node of mutation.addedNodes) {
        /*                         */
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        const elementToProcess = node as HTMLElement;

        if (elementToProcess.matches(prevQuery))
          updateElementWithGuardedUrl(elementToProcess, prevUrlGuarded.value);

        if (elementToProcess.matches(closeQuery))
          updateElementWithGuardedUrl(elementToProcess, closeUrlGuarded.value);

        if (elementToProcess.matches(useCloseUrlQuery))
          extendElementWithCloseUrlQueryParam(elementToProcess, closeUrlGuarded.value);
      }
    });
  });

  $effect(() => {
    if (!closeUrlGuarded.value && !prevUrlGuarded.value) {
      isObserverConnected = false;
      return linkAnchorUpdateObserver.disconnect();
    }

    if (!isObserverConnected) {
      isObserverConnected = true;
      linkAnchorUpdateObserver.observe(Host, { childList: true, subtree: true });
    }

    /*                                                      */
    /*                                                            */
    Host.querySelectorAll<ProcessableElement>(prevQuery).forEach((el) =>
      updateElementWithGuardedUrl(el, prevUrlGuarded.value),
    );
    Host.querySelectorAll<ProcessableElement>(closeQuery).forEach((el) =>
      updateElementWithGuardedUrl(el, closeUrlGuarded.value),
    );

    /*                                                                   */
    if (closeUrlGuarded.value)
      Host.querySelectorAll<ProcessableElement>(useCloseUrlQuery).forEach((el) =>
        extendElementWithCloseUrlQueryParam(el, closeUrlGuarded.value),
      );

    return () => {
      isObserverConnected = false;
      linkAnchorUpdateObserver.disconnect();
    };
  });
};
